import { Component, computed, input } from '@angular/core';
import { computeFillPercent } from '../v3-scores-overview/score-fill';

// A single clickable "tile" in V3FundamentalScoresAnalysis's top category menu — visually
// close to V3ScoreCard (same header/track/fill structure) but selectable, so kept as its
// own component rather than overloading V3ScoreCard's read-only overview usage.
@Component({
  selector: 'app-v3-score-category-tab',
  imports: [],
  standalone: true,
  templateUrl: './v3-score-category-tab.html',
  styleUrl: './v3-score-category-tab.scss',
})
export class V3ScoreCategoryTab {
  readonly label = input.required<string>();
  readonly value = input.required<number>();
  readonly max = input.required<number>();
  /** V3 score-tier CSS custom property name (e.g. '--v3-score-good'). */
  readonly colorVar = input.required<string>();
  readonly isRatingSuspended = input(false);
  readonly active = input(false);

  readonly fillPercent = computed(() =>
    computeFillPercent(this.value(), this.max(), this.isRatingSuspended()),
  );
}
